module.exports = __webpack_public_path__ + "static/media/share_and_export_fpo.09ba1d99.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/share_and_export_fpo.png
 ** module id = 291
 ** module chunks = 0
 **/